"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("./validations");
function dateToEpochSeconds(date) {
    if ((0, validations_1.isNullOrUndef)(date)) {
        // @ts-ignore - maybe throw error?
        return null;
    }
    // Hacky test to see if epoch seconds
    if ((0, validations_1.isNumber)(date) && Math.floor(Math.log10(date)) === 9) {
        return date;
    }
    return Math.ceil(new Date(date).getTime() / 1000);
}
exports.default = dateToEpochSeconds;
